// Sends the customer's receipt confirmation before the form goes to Shopify as usual.
// The withdrawal itself must never depend on this: whatever happens here, the form is
// still submitted, and its status field tells the shop whether the customer got the mail.
//
// Shopify's captcha script also listens for submit and submits the form straight away. So this
// listener runs first, in the capture phase on window, and holds the event back. Once the
// confirmation is done it submits again and lets Shopify's own handling take over.
(function () {
  const config = document.currentScript.dataset;
  const form = document.getElementById('widerruf-form');
  if (!form || !config.endpoint) return;

  const REQUEST_TIMEOUT = 12000;
  const CAPTCHA_TIMEOUT = 6000;
  let state = 'idle';
  let token = null;
  let onToken = null;

  const addHidden = (name, value) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `contact[${name}]`;
    input.value = value;
    form.append(input);
    return input;
  };
  const status = addHidden('Bestaetigung an Kunden', 'NICHT GESENDET: Browser hat den Dienst nicht erreicht');
  const receivedAt = addHidden('Eingang', new Date().toISOString());

  const value = (field) => {
    const input = form.elements[`contact[${field}]`];
    return input ? input.value : '';
  };

  if (config.sitekey) {
    const container = document.createElement('div');
    form.querySelector('[type="submit"]').before(container);
    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.onload = () => {
      window.turnstile.render(container, {
        sitekey: config.sitekey,
        appearance: 'interaction-only',
        callback: (result) => {
          token = result;
          if (onToken) onToken();
        },
      });
    };
    document.head.append(script);
  }

  const waitForToken = () =>
    new Promise((resolve) => {
      if (token) return resolve();
      onToken = resolve;
      setTimeout(resolve, CAPTCHA_TIMEOUT);
    });

  const sendConfirmation = async () => {
    await waitForToken();
    const response = await fetch(config.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      signal: AbortSignal.timeout(REQUEST_TIMEOUT),
      body: JSON.stringify({
        name: value('name'),
        email: value('email'),
        order_number: value('order_number'),
        order_date: value('order_date'),
        received_date: value('received_date'),
        items: value('body'),
        token,
      }),
    });
    const result = await response.json();
    if (result.received_at) receivedAt.value = result.received_at;
    status.value = result.ok ? 'Gesendet' : `NICHT GESENDET: ${result.error}`;
  };

  window.addEventListener(
    'submit',
    async (event) => {
      if (event.target !== form || state === 'done') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (state === 'sending') return;
      state = 'sending';

      const button = form.querySelector('[type="submit"]');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        await sendConfirmation();
      } catch (error) {
        status.value = `NICHT GESENDET: ${error.name}`;
      }

      state = 'done';
      button.disabled = false;
      form.requestSubmit();
    },
    true
  );
})();
